<template>
  <div>
      <tplheader></tplheader>
      <tplLeftPanel></tplLeftPanel>
    <form>
      <div id="fixed-top-menu-outer" class="fixed-top-menu-outer">
        <div class="fixed-top-menu">
          <div class="pull-right">
            <router-link class="btn btn-primary" :to="{ path: '/card_owner/edit' }"><i class="fa fa-plus"></i>Új kártyabirtokos</router-link>
          </div>
        </div>
      </div>
      <div id="main-panel" class="main-panel">
        <div class="content-panel">
          <ul class="breadcrumb">
            <li>Kezdőőoldal</li>
            <li>Kártyabirtokosok</li>
          </ul>
          <div class="page-title">
            <h1><i class="material-icons">chevron_right</i>Kártyabirtokosok</h1>
          </div>
          <div class="content-panel-top-btn-group">
            <router-link class="btn btn-primary" :to="{ path: '/card_owner/edit' }"><i class="fa fa-plus"></i>Új kártyabirtokos</router-link>
          </div>
          <div class="panel">
            <div class="panel-heading">
              <h4>Kártyabirtokosok</h4>
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-xs-12">
                  <div class="row">
                    <div class="col-xs-12">
                      <div class="panel-sub-heading"><h4>Kereső</h4></div>
                    </div>
                    <div class="col-xs-2">
                      <inputbox id="name" :keydownEnter="searchClick" label="Név" name="name" v-model="search.name"></inputbox>
                    </div>
                    <div class="col-xs-2">
                      <inputbox inputCheck="neptuncode" maxlength="6" id="neptuncode" :keydownEnter="searchClick" label="Neptunkód" name="neptuncode" v-model="search.neptuncode"></inputbox>
                    </div>
                    <div class="col-xs-2">
                      <inputbox inputCheck="orgware" maxlength="8" id="orgware_id" :keydownEnter="searchClick" label="Törzsszám" name="orgware_id" v-model="search.orgware_id"></inputbox>
                    </div>
                    <div class="col-xs-2">
                      <inputbox id="email" :keydownEnter="searchClick" label="Email" name="email" v-model="search.email"></inputbox>
                    </div>
                    <div class="col-xs-3">
                      <button class="btn btn-white" style="margin-top:12px" type="button" v-on:click="searchClick"><i class="fa fa-search"></i>Keresés</button>
                    </div>
                  </div>
                </div>

                <div class="col-xs-12">
                  <div v-if="card_owners.length">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Név</th>
                        <th>Email</th>
                        <th>Telefon</th>
                        <th>Neptunkód</th>
                        <th>AD Felh.név</th>
                        <th>Törzsszám</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="owner in card_owners">
                        <td>{{owner.id}}</td>
                        <td>{{owner.name}}</td>
                        <td>{{owner.email}}</td>
                        <td>{{owner.phone}}</td>
                        <td>{{owner.neptun_code}}</td>
                        <td>{{owner.ad_username}}</td>
                        <td>{{owner.orgware_id}}</td>
                        <td>
                          <ul class="icon-list">
                            <li class="dropdown"><a class="dropdown-toggle" href="javascript:void(0)"><i class="fa fa-gear"></i></a>
                              <ul class="dropdown-menu">
                                <li class="dropdown-header">Opciók</li>
                                <li><router-link :to="{ path: '/card_owner/edit/', query: { id: owner.id }}"><i class="fa fa-pencil-square-o"></i>Szerkeszt</router-link></li>
                              </ul>
                            </li>
                          </ul>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <pagination showcombo="1" :limit="query.limit" :amount="query.amount" v-on:pageChanged="pageChanged" v-model="query.page"></pagination>
                  </div>
                  <div v-else>
                    Nem található kártyabirtokos.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

  </div>
</template>
<script>
import tplheader from './tpl_header.vue';
import tplLeftPanel from './tpl_leftpanel.vue';

export default {
  components: {
    tplheader,
    tplLeftPanel
  },
  data: function() {
    return {
      query: {
        name: '',
        email: '',
        neptuncode: '',
        page: 1,
        limit: 100,
        amount: 0
      },
      search: {
        name: '',
        email: '',
        orgware_id: ''
      },
      card_owners: [],
    }
  },
  watch: {
    '$route': 'routerChange'
  },
  methods: {
    routerChange: function() {
      if (Object.keys(this.$route.query).length != 0) {
        this.query = JSON.parse(JSON.stringify(this.$route.query));
        this.search.name = this.query.name;
        this.search.email = this.query.email;
        this.search.neptuncode = this.query.neptuncode;
        this.search.orgware_id = this.query.orgware_id;
      } else {
        this.query = {
          name: '',
          email: '',
          neptuncode: '',
          orgware_id: '',
          page: 1,
          limit: 100,
          amount: 0
        };
        this.search.name = '';
        this.search.email = '';
        this.search.neptuncode = '';
        this.search.orgware_id = '';
      }
      this.getList();
    },
    pageChanged: function(val) {
      this.query.page = val;
      this.$router.push({path: '/card_owners/list', query: this.query});
    },

    searchClick: function() {
      this.query.page = 1;
      this.query.name = this.search.name;
      this.query.email = this.search.email;
      this.query.neptuncode = this.search.neptuncode;
      this.query.orgware_id = this.search.orgware_id;

      this.$router.push({path: '/card_owners/list', query: this.query});
    },

    getList: function() {
      var _this = this;

      this.$root.ajax('card_owners/list', {
        data: this.query,
        method: 'POST',
        success: function(response) {
          _this.card_owners = response.card_owners;
          _this.query.amount = response.amount;
        }
      });
    }
  },

  created: function() {
    this.routerChange();
  }
}
</script>


// WEBPACK FOOTER //
// cardowners.vue?10b12be8